import authApi from "../../utils/AxiosConfig"
import authHeader from "../../utils/authHeader"

const getMe = async (token: string) => {
    const response = await authApi.get('/auth/me', {
        headers: authHeader(token),
    });
    return response;
};

// Login
const login = async (formData: any) => {
    const response = await authApi.post('/auth/login', formData)
    return response.data
}

// Logout
const logout = async () => {
    const response = await authApi.post('/auth/logout')
    if (response.data) {
        localStorage.removeItem('presist:root')
    }
}

// Register
const register = async (formData: any) => {
    const response = await authApi.post('/auth/register', formData)
    return response.data
}

const authService = {
    getMe,
    login,
    register,
    logout
}

export default authService